import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Utils from "../core/Utils";
import { Container } from "@mui/material";
import { postAsync, getToken } from "../core/serviceClient";
import { setLogin, setToken, getEnterpriseId } from "../data/localSettingsActions";
import AppSettings from "../appsettings.json";
import { CanUseWebApp } from "../core/ModuleHelper";
import { connectToStore } from "../data/store";
import { LoginPage, OverviewPage } from "../core/PageConstants";
import UserHelper from "../core/UserHelper";

function Landing() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [navigateToLogin, setNavigateToLogin] = useState(false);

  useEffect(() => {
    const asyncFn = async () => {
      let localSettings = connectToStore();
      if (Utils.IsNullOrEmptyObject(localSettings) || Utils.IsNullOrEmptyObject(localSettings.user) || Utils.IsNullOrEmptyObject(localSettings.business)) {
        setNavigateToLogin(true);
        return;
      }
      var tokenResponse = await getToken();
      if (Utils.IsNullOrEmptyObject(tokenResponse) || Utils.IsNullOrEmptyObject(tokenResponse.data) || tokenResponse.error) {
        setNavigateToLogin(true);
        return;
      }
      setToken(tokenResponse.data.token, dispatch);
      var request = {
        BusinessId: localSettings.user.businessId,
        CountryCode: localSettings.user.countryCode,
        LoginId: localSettings.user.id,
        LoggedInWith: localSettings.loggedInWith,
        ProductsDT: localSettings.productsDT,
        PublicKey: AppSettings.PublicKey,
        PublicKeyType: localSettings.publicKeyType,
        Secret: AppSettings.Secret,
        Token: tokenResponse.data.token,
        IsWebApp: true,
        EnterpriseId: getEnterpriseId(),
      };
      let response = await postAsync("Account/Login", request);
      if (response.error) {
        setNavigateToLogin(true);
        return;
      }
      if (!CanUseWebApp(localSettings.business)) {
        setNavigateToLogin(true);
        return;
      }
      setLogin(response.data, dispatch);
      navigate(OverviewPage.Path);
    };
    asyncFn();
  }, []);

  useEffect(() => {
    login();
  }, [navigateToLogin]);

  const login = () => {
    if (navigateToLogin) {
      UserHelper.LogOut(dispatch);
      localStorage.clear();
      navigate(LoginPage.Path);
    }
  };

  return (
    <Container maxWidth="full" className="main" sx={{ display: "flex" }}>
      <div id="indexLoading">
        <p>
          <img src="logo192.png" alt="Infopoint" />
        </p>
      </div>
    </Container>
  );
}

export default Landing;
